import { render } from "./ObservationsField.vue?vue&type=template&id=d524c94a&scoped=true"
import script from "./ObservationsField.vue?vue&type=script&lang=js"
export * from "./ObservationsField.vue?vue&type=script&lang=js"

import "./ObservationsField.vue?vue&type=style&index=0&id=d524c94a&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d524c94a"]])

export default __exports__